import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    text: {
      margin: 0
    },
    dateText: {
      margin: 0,
      display: 'flex',
      gap: '5px'
    },
    block1: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px'
    },
    title: {
      color: palette.common.black,
      margin: 0,
      fontSize: '32px'
    },
    infos: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      fontSize: '15px',
      fontWeight: 500
    },
    block2: {
      display: 'flex',
      gap: '30px',
      '@media (max-width: 1024px)': {
        flexDirection: 'column',
        gap: '20px'
      }
    }
  });
const useStyle = makeStyles(style);
export default useStyle;
